import axiosvl from "../../../axios/axios-vl.js";
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';

export default {
    async addToCart(context, payload) {
        let storefrontBOsetting = context.rootGetters['storefrontAttributes'].find(attribute => attribute.type === 'BKO').value;
        let customerBOsetting = context.rootGetters['getCustomerDetails'].allowbackorder;
        const backorderallowed = storefrontBOsetting === 'Y' && customerBOsetting === 'Y';

        // Add item to the cart regardless of whether it is already there or not        
        if (payload.linenumber === 0 || payload.linenumber === undefined) {
            let cartlinecount = 0;
            cartlinecount = context.state.cart.length;

            cartlinecount = 0 || undefined ? 1 : (cartlinecount + 1);
            payload.linenumber = cartlinecount;
        }

        const linetotal = payload.quantity * payload.yourprice;
        let image = payload.image;
        let isBO = false;
        const timeout = (image == null || image == '') ? 1000 : 0;
        // if image is null
        if(image == null || image == ''){
            // get product image from cloudinary 
            const clApi = new CloudinaryApi;
            clApi.item_sku = payload.ID;
            clApi.manufacturer_code = payload.manufacturer;
            await clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                console.log('imgURL = ' + imgURL);
                if(imgURL){
                    image = imgURL;
                }else{
                    image = GCONST.IMAGE_PLACEHOLDER;
                }
            });
        }

        // set delay to have time for the image to be populated from the web service
        setTimeout(() => {
            
            // We are allowing to purchase more than stock quantity for B2C also
            // issue #260
            // https://gitlab.com/lansa/dms_ecommerce/-/issues/260#note_686460047
            if (payload.quantity > payload.stockquantity) {
                // BACKORDER flag is for B2B users only
                if(context.rootGetters['customerIndicator'] == 'B' && backorderallowed == true){
                    isBO = true;
                }else{
                    isBO = false;
                }
            } else {
                isBO = false;
            }

            const newItem = {
                ID        : payload.ID,
                linenumber: payload.linenumber,
                item: payload.item,
                desc: payload.desc,
                manufacturer: payload.manufacturer,
                image: image,
                quantity: payload.quantity,
                listprice: payload.listprice,
                corecharge: payload.corecharge,
                yourprice: payload.yourprice,
                shipping: payload.shipping,
                linetotal: linetotal,
                stockquantity: payload.stockquantity,
                backorder: isBO,

                mfgSeo: payload.mfgSeo,
                itemSeo: payload.itemSeo,
                
                // locations
                locationid: payload.locationid,
                locationname: payload.locationname,
                locationcity: payload.locationcity,
                locationstate: payload.locationstate,

                // additional fields to be in the cart items
                XRMFGC: (payload.XRMFGC != undefined) ? payload.XRMFGC : '',
                XRITMC: (payload.XRITMC != undefined) ? payload.XRITMC : '',
                IMIGSA: (payload.IMIGSA != undefined) ? payload.IMIGSA : '',
                IMISVALID: (payload.IMISVALID != undefined) ? payload.IMISVALID : '',
                carrier: '',
            };

            context.commit('addToCart', newItem);

            context.dispatch('calculateTotals');

            const customerIndicator = context.rootGetters['customerIndicator'];
            const SRT_VAL = context.rootGetters['storefrontAttributes'].find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;
        
            if (SRT_VAL == 'ORDERTOTAL'){
                context.dispatch('shipping_by_order_total');
            }
        }, timeout);
    },

    kitToCart(context, payload){
        // console.log(payload);
        context.commit('kitToCart', payload);

        context.dispatch('calculateTotals');

        const customerIndicator = context.rootGetters['customerIndicator'];
        const SRT_VAL = context.rootGetters['storefrontAttributes'].find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;
    
        if (SRT_VAL == 'ORDERTOTAL'){
            context.dispatch('shipping_by_order_total');
        }
    },
    updateCart(context, payload) {
        // Add or update an item to/in the cart

        // const productInCartIndex = context.state.cart.findIndex( (ci) => ci.ID === payload.ID );
        const productInCartIndex = context.state.cart.findIndex( 
            (ci) => 
                ci.item === payload.item &&
                ci.manufacturer === payload.manufacturer &&
                ci.locationid === payload.locationid &&
                ci.linenumber === payload.linenumber 
        );
        let productData = context.state.cart;

        if (productInCartIndex >= 0) {
            let newqty = 0;
            if (payload.isupdating) {
                newqty = parseInt(payload.quantity);
            } else {
                newqty = parseInt(productData[productInCartIndex].quantity) + parseInt(payload.quantity);
            }
            const linetotal = newqty * payload.yourprice;

            productData[productInCartIndex].quantity = newqty;
            productData[productInCartIndex].linetotal = linetotal;

            // We are allowing to purchase more than stock quantity for B2C also
            // issue #260
            // https://gitlab.com/lansa/dms_ecommerce/-/issues/260#note_686460047
            if (productData[productInCartIndex].quantity > payload.stockquantity) {
                // BACKORDER flag is for B2B users only
                if(context.rootGetters['customerIndicator'] == 'B'){
                    productData[productInCartIndex].backorder = true;
                }else{
                    productData[productInCartIndex].backorder = false;
                }
            } else {
                productData[productInCartIndex].backorder = false;
            }

            context.commit('updateCart', productData);
        } else {
            const linetotal = payload.quantity * payload.yourprice;

            // // If backordre is not allowed, check that the new quantity does not exceed the stock quantity 
            // if (!backorderallowed) {
            //     if (payload.quantity > payload.stockquantity) {
            //         // Error - do not continue
            //     }
            // }

            const newItem = {
                ID        : payload.ID,
                linenumber: payload.linenumber,
                item: payload.item,
                desc: payload.desc,
                manufacturer: payload.manufacturer,
                image: payload.image,
                quantity: payload.quantity,
                listprice: payload.listprice,
                corecharge: payload.corecharge,
                yourprice: payload.yourprice,
                shipping: payload.shipping,
                linetotal: linetotal,
                stockquantity: payload.stockquantity,
                backorder: payload.backorder,
                locationid: payload.locationid,
                locationname: payload.locationname,
                locationcity: payload.locationcity,
                locationstate: payload.locationstate,
                carrier: '',
            };
            context.commit('addToCart', newItem);
        }

        context.dispatch('calculateTotals');
        var onehr = new Date(new Date().getTime() + 60 * 60 * 1000);
        context.dispatch("cart_expiration", {cart_expiration : onehr});

        const customerIndicator = context.rootGetters['customerIndicator'];
        const SRT_VAL = context.rootGetters['storefrontAttributes'].find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;

        if (SRT_VAL == 'ORDERTOTAL'){
            context.dispatch('shipping_by_order_total');
        }
    },
    updateCartLine(context, payload) {
        context.commit('updateCartLine', payload);
        context.dispatch('calculateTotals');

        const customerIndicator = context.rootGetters['customerIndicator'];
        const SRT_VAL = context.rootGetters['storefrontAttributes'].find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;

        if (SRT_VAL == 'ORDERTOTAL'){
            context.dispatch('shipping_by_order_total');
        }
    },
    updateCartCarrier(context, payload){
        let productData = context.state.cart;

        productData.forEach(function(obj) {
            if (obj.locationid === payload.location) {
                obj.carrier = payload.carrier;
            }
        });

        context.commit('updateCart', productData);
    },
    emptyCart(context) {
        context.commit('emptyCart');
        context.dispatch('calculateTotals');
    },
    removeCartLine(context, payload) {
        
        // Do AjAX to remove the cart line here
        context.commit('removeCartLine', payload);
        context.dispatch('calculateTotals');

        if (context.state.cart.length === 0) {
            // If the cart is empty, remove the selected vehicle
            context.dispatch('vehicle/clearSelectedVehicle', '', { root: true });
        }
        
        const customerIndicator = context.rootGetters['customerIndicator'];
        const SRT_VAL = context.rootGetters['storefrontAttributes'].find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;

        if (SRT_VAL == 'ORDERTOTAL' && context.state.cart.length > 0){
            context.dispatch('shipping_by_order_total');
        }
    },

    emptyKits(context) {
        context.commit('emptyKits');
        context.dispatch('calculateTotals');
    },

    updateKitComponent(context, payload) {
        context.commit('updateKitComponent', payload);
        context.dispatch('calculateTotals');
    },

    removeKitLine(context, payload) {
        
        // Do AjAX to remove the cart line here
        context.commit('removeKitLine', payload);
        context.dispatch('calculateTotals');

        if (context.state.cart.length === 0) {
            // If the cart is empty, remove the selected vehicle
            context.dispatch('vehicle/clearSelectedVehicle', '', { root: true });
        }
        
        const customerIndicator = context.rootGetters['customerIndicator'];
        const SRT_VAL = context.rootGetters['storefrontAttributes'].find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;

        if (SRT_VAL == 'ORDERTOTAL' && context.state.cart.length > 0){
            context.dispatch('shipping_by_order_total');
        }
    },
    totals(context, payload) {
        // console.log(payload);
        context.commit('totals', payload);
    },
    promocode(context, payload) {
        context.commit('promocode', payload);
    },

    // Local Actions
    calculateTotals(context) {
        // Right after updating the cart, recalculate the totals
        let subtotal = 0, // = total amount exluding back order totals
            coretotal = 0, // = core charges total
            taxtotal = 0, // tax application total
            shippingtotal = parseFloat(context.state.totals[0].shippingtotal), 
            ordertotal = 0, // = items amount total subtotal + backorder total
            backordered_total = 0, // back ordered total amount
            shipping_handling_total = 0;
        let discount_total = 0;

        let row = null;
        // console.log(context.state.kits);
        // normal items on cart
        for (let x = 0; x < context.state.cart.length; x++) {
            row = context.state.cart[x];
            // console.log(row);
            coretotal += row.quantity > 0 ? row.corecharge : 0;
            ordertotal += row.quantity > 0 ? (row.yourprice * row.quantity) + row.corecharge : 0;
            if (row.backorder == true){
                backordered_total += row.quantity > 0 ? (row.yourprice * row.quantity) : 0;
            }else{
                subtotal += (row.yourprice * row.quantity);
            }
        }

        // kits and components from the cart
        // loop first on the kit master
        // console.log(context.state.kits);
        context.state.kits.forEach(kit => {
            // console.log(kit.kit_items);
            // loop on the kit components
            kit.kit_items.forEach(ki => {
                // console.log(ki);
                coretotal += ki.quantity > 0 ? ki.corecharge : 0;
                ordertotal += ki.quantity > 0 ? (ki.yourprice * ki.quantity) + ki.corecharge : 0;
                if (kit.backorder == true){
                    backordered_total += ki.quantity > 0 ? (ki.yourprice * ki.quantity) : 0;
                }else{
                    subtotal += (ki.yourprice * ki.quantity);
                }
            });
        });

        // apply promo code in subtotals
        if(context.state.promo_code.length > 0){
            // console.table(context.state.promo_code);
            context.state.promo_code.forEach((promo, promoIndx) => {
                console.log(promo);
                console.log(promoIndx);
                let amnt_dc = 0;
                let items_amnt = 0;
                let item_total_line = 0;
                if(promo.to_item != ""){
                    // update promo discount description
                    promo.desc = promo.main_desc;
                    //  + ' - ITEM: '+ promo.to_item;
                    promo.index = promoIndx;

                    // find the items from the cart that have discount by item code
                    const items_dc = context.state.cart.filter((i) => i.item == promo.to_item);
                    let kit_components = [];

                    // find items that have discount by Sales analysis code from the kit components
                    context.state.kits.forEach(km => {
                        km.kit_items.forEach(kc => {
                            if(kc.item == promo.to_item){
                                kit_components.push(kc);
                            }
                        });
                    });

                    // console.log(kit_components);

                    if(items_dc.length > 0 || kit_components.length > 0){
                        items_dc.forEach(idc => {
                            item_total_line += idc.quantity > 0 ? (idc.yourprice * idc.quantity) + idc.corecharge : 0;
                        });

                        kit_components.forEach(idc => {
                            item_total_line += idc.quantity > 0 ? (idc.yourprice * idc.quantity) + idc.corecharge : 0;
                        });

                        // fixed discount
                        if (promo.fixed_dc > 0){
                            items_amnt += promo.fixed_dc;
                            amnt_dc = promo.fixed_dc;
                        }

                        // percentage discount
                        if (parseInt(promo.percent_dc) > 0){
                            const amnt_perc = (item_total_line * (promo.percent_dc / 100));
                            amnt_dc = amnt_perc;
                            items_amnt += amnt_perc;
                        }
                        // console.log('items_amnt = ' + items_amnt);
                        discount_total += items_amnt;
                        promo.amnt_dc = items_amnt;
                        
                    }else{
                        promo.amnt_dc = 0;
                        // console.log(promo.to_item);
                        // console.log(promo);
                        // context.commit('deletePromoCode', promo);
                    }
                    context.commit('updatePromoCode', promo);
                    return;
                }

                // SAG PROMO CODE
                if(promo.to_sag != ""){
                    // update promo discount description
                    promo.desc = promo.main_desc;
                    promo.index = promoIndx;
                    // find the items that have discount by Sales analysis code
                    // console.log(context.state.cart);
                    const sag_dc = context.state.cart.filter((i) => i.IMIGSA == promo.to_sag);
                    // console.table(sag_dc);
                    let kit_components = [];

                    // find items that have discount by Sales analysis code from the kit components
                    context.state.kits.forEach(km => {
                        km.kit_items.forEach(kc => {
                            // console.log(kc);
                            if(kc.IMIGSA == promo.to_sag){
                                kit_components.push(kc);
                            }
                        });
                    });

                    if(sag_dc.length > 0 || kit_components.length > 0){
                        sag_dc.forEach(idc => {
                            item_total_line += idc.quantity > 0 ? (idc.yourprice * idc.quantity) + idc.corecharge : 0;
                        });

                        kit_components.forEach(idc => {
                            item_total_line += idc.quantity > 0 ? (idc.yourprice * idc.quantity) + idc.corecharge : 0;
                        });

                        // fixed discount
                        if (promo.fixed_dc > 0){
                            items_amnt += promo.fixed_dc;
                            amnt_dc = promo.fixed_dc;
                        }

                        // percentage discount
                        if (parseInt(promo.percent_dc) > 0){
                            const amnt_perc = (item_total_line * (promo.percent_dc / 100));
                            amnt_dc = amnt_perc;
                            items_amnt += amnt_perc;
                        }
                        discount_total += items_amnt;
                        promo.amnt_dc = items_amnt;
                        console.table(promo);
                        
                    }else{
                        promo.amnt_dc = 0;
                        // console.log(promo);
                        // context.commit('deletePromoCode', promo);
                    }
                    context.commit('updatePromoCode', promo);
                    return;
                }
                // end of SAG PROMO

                // console.log('regular');
                
                // fixed discount
                if (promo.fixed_dc > 0){
                    discount_total += promo.fixed_dc;
                    amnt_dc = promo.fixed_dc;
                }

                // percentage discount
                if (parseInt(promo.percent_dc) > 0){
                    const amnt_perc = (ordertotal * (promo.percent_dc / 100));
                    amnt_dc = amnt_perc;
                    discount_total += amnt_perc;
                }

                promo.desc = promo.main_desc;
                promo.amnt_dc = amnt_dc;
                promo.index = promoIndx;
                context.commit('updatePromoCode', promo);
            });
        }

        ordertotal -= discount_total;

        if (context.state.cart.length == 0 && context.state.kits.length == 0) {
            shippingtotal = 0;
        }

        if (context.rootGetters['customerIndicator'] == 'C'){
            taxtotal = ordertotal * parseFloat(context.state.tax_rate);
        }else{
            taxtotal = 0;
        }
        ordertotal = ordertotal + taxtotal + shippingtotal;
        
        context.state.totals = [];

        context.commit('totals', {
            subtotal: subtotal.toFixed(2),
            coretotal: coretotal.toFixed(2),
            taxtotal: taxtotal.toFixed(2),
            shippingtotal: shippingtotal.toFixed(2),
            ordertotal: ordertotal.toFixed(2),
            backordered_total: backordered_total.toFixed(2),
            shipping_handling_total: shipping_handling_total.toFixed(2),
            discounttotal: discount_total.toFixed(2),
        });
    },

    billingdetails (context, payload) {
        context.commit('billingdetails', payload);
    },
    shippingdetails (context, payload) {
        context.commit('shippingdetails', payload);
    },
    orderdetails (context, payload) {
        context.commit('orderdetails', payload);
    },
    ordersuccess (context, payload) {
        context.commit('ordersuccess', payload);
    },

    set_order_notes(context, payload) {
        context.commit('order_notes', payload);
    },

    cc_details(context, payload) {
        context.commit('cc_details', payload);
    },

    rebuildItemPricing(context) {
        let currentcart = context.state.cart;
        let currentkits = context.state.kits;
        
        // const defaultLoc = context.rootGetters.getCustomerDetails;
        // console.log(defaultLoc);
        // loop through items of the cart
        if(currentcart.length > 0){
            for (let x = 0; x < currentcart.length; x++) { 
                axiosvl.post(context.rootGetters['api/product_details_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": { "value": context.rootGetters['customer'] },
                            "EIMFGC": { "value": currentcart[x].manufacturer },
                            "EIITMC": { "value": currentcart[x].item },
                        },   
                    }
                })
                .then((response) => {
                    const fields = response.data.webroutine.fields;

                    if (fields.RESULTCOD.value === 'OK') {
                        let obj = {
                            index: x,
                            yourprice: fields.EIEXCP.value,
                            listprice: fields.EILSTP.value,
                            corecharge: fields.EICORP.value,
                            linetotal: currentcart[x].quantity * fields.EIEXCP.value,

                            // added location to update the location
                            // locationid: defaultLoc.defaultlocationid,
                            // locationname: defaultLoc.defaultlocationname,
                            // locationcity: defaultLoc.defaultlocationcity,
                            // locationstate: defaultLoc.defaultlocationstate,
                        }
                        // console.log(obj);
                        context.dispatch('updateCartLine', obj);
                    } else {
                        // if the data is unavailable, remove this line from the cart
                        context.dispatch('removeCartLine', { "index": x });
                    }


                })
                .catch((error) => {
                    console.log("error - " + error);
                    context.dispatch('removeCartLine', { "index": x });
                });
            }
        }

        // console.log(currentkits);
        // loop through kit and kit components
        if(currentkits.length > 0){
            currentkits.forEach((km, km_index) => {
                // console.log(km.kit_items);
                km.kit_items.forEach((kc, kc_index) => {
                    // console.log(kc)
                    axiosvl.post(context.rootGetters['api/product_details_uri'], {
                        "webroutine": {
                            "context": {
                                "session-key-method": "hidden"
                            },
                            "fields": {
                                "EHCUST": { "value": context.rootGetters['customer'] },
                                "EIMFGC": { "value": kc.manufacturer },
                                "EIITMC": { "value": kc.item },
                            },   
                        }
                    })
                    .then((response) => {
                        const fields = response.data.webroutine.fields;
        
                        if (fields.RESULTCOD.value === 'OK') {
                            let obj = {
                                km_index : km_index,
                                kc_index : kc_index,
                                yourprice: fields.EIEXCP.value,
                                listprice: fields.EILSTP.value,
                                corecharge: fields.EICORP.value,
                                linetotal: kc.quantity * fields.EIEXCP.value,
                            }
                            // console.log(obj);
                            context.dispatch('updateKitComponent', obj);
                        } else {
                            // if the data is unavailable, remove this line from the cart
                            // context.dispatch('removeCartLine', { "index": x });
                        }
                    })
                    .catch((error) => {
                        console.log("error - " + error);
                        // context.dispatch('removeCartLine', { "index": kc_index });
                    });
                });
            });
        }
    },

    update_tax_rate(context, payload) {
        context.commit('update_tax_rate', payload);
    },

    cc_saved_id(context, payload) {
        context.commit('cc_saved_id', payload);
    },

    /** mutate to_save_new_cc state */
    to_save_new_cc(context, payload) {
        context.commit('to_save_new_cc', payload);
    },


    /**
     * update shipping rate by order total
     * on each update of cart items 
     * update shipping rate
     */
    shipping_by_order_total(context) {
        const totals = context.rootGetters['cart/totals'];
        axiosvl.post(context.rootGetters['api/ship_rate_uri'], {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    "LW3SFID": { "value": context.rootGetters['storefront'] },
                    // "HOSTURL": { "value": context.rootGetters['hosturl'] },
                    "LW3CUSIND": { "value": context.rootGetters['customerIndicator'] },
                    "LW3ORDTOT": { "value": totals[0].ordertotal },
                },   
            }
        })
        .then((response) => {
            // console.table(response.data.webroutine.lists.LS_SHIPPINGRATES.entries);

            if (response.data.webroutine.lists.LS_SHIPPINGRATES.entries.length == 0) {
                totals[0].shippingtotal = 0;
            }
            
            for (const key in response.data.webroutine.lists.LS_SHIPPINGRATES.entries) { 
                const obj = response.data.webroutine.lists.LS_SHIPPINGRATES.entries[key];
                totals[0].shippingtotal = obj.LW3SHPAMT;
            }

            let ordertotal = parseFloat(totals[0].subtotal) + + parseFloat(totals[0].backordered_total) + parseFloat(totals[0].coretotal);

            let discount_total = 0;
            // apply promo code in subtotals
            // console.log('shipping_by_order_total');
            context.state.promo_code.forEach((promo) => {
                // let amnt_dc = 0;
                // // fixed discount
                // if (promo.fixed_dc > 0){
                //     discount_total += promo.fixed_dc;
                //     amnt_dc = promo.fixed_dc;
                // }

                // // percentage discount
                // if (parseInt(promo.percent_dc) > 0){
                //     const amnt_perc = (ordertotal * (promo.percent_dc / 100));
                //     amnt_dc = amnt_perc;
                //     discount_total += amnt_perc;
                // }

                // promo.amnt_dc = amnt_dc;
                // promo.index = i;
                // context.commit('updatePromoCode', promo);
                discount_total += promo.amnt_dc;
            });
            
            ordertotal =  ordertotal - discount_total;

            totals[0].ordertotal = parseFloat(ordertotal) + parseFloat(totals[0].shippingtotal) + parseFloat(totals[0].taxtotal);
            context.commit('totals', totals[0]);
        })
        .catch((error) => {
            console.log("error - " + error);
        });
    },

    updateShippingDiff(context, payload){
        context.commit('updateShippingDiff', payload);
    },

    po_required(context, payload){
        context.commit('po_required', payload);
    },

    cart_expiration(context, payload){
        context.commit('cart_expiration', payload);
    },

    carrier(context, payload) {
        context.commit('carrier', payload);
    },
    
    ordered_items(context, payload) {
        context.commit('ordered_items', payload);
    },

    backordered_items(context, payload) {
        context.commit('backordered_items', payload);
    },
    
    emptyOrderItems(context) {
        context.commit('empty_ordered_items');
    },

    emptyPromo(context) {
        context.commit('emptyPromo');
    },

    setPromo_code(context, payload) {
        context.commit('setPromo_code', payload);
    },

    updatePromoCode(context, payload){
        context.commit('updatePromoCode', payload);
    },

    setCEDKOE(context, payload){
        context.commit('setCEDKOE', payload);
    }
}